import { useShallow } from "zustand/react/shallow";
import { useTownStore } from "../state/store";

/** Stable fallback: a fresh `[]` per selector call would defeat `useShallow` and trip React's getSnapshot check. */
const NO_NOTICES: ReadonlyArray<{ code: string; message: string }> = Object.freeze([]);

/** Short notices the server asks the UI to show (e.g. TEST_MODE), dismissible per session. */
export function NoticeBar() {
  const { notices, dismissed } = useTownStore(useShallow((s) => ({ notices: s.bootstrap?.notices ?? NO_NOTICES, dismissed: s.ui.dismissedNotices })));
  const dismiss = useTownStore((s) => s.dismissNotice);
  const visible = notices.filter((n) => !dismissed.includes(n.code));
  if (visible.length === 0) return null;
  return (
    <div className="stack" style={{ gap: 4 }}>
      {visible.map((n) => (
        <div key={n.code} className="notice notice-warning row small" role="status">
          <span style={{ flex: 1 }}>{n.message}</span>
          <button type="button" className="btn btn-sm btn-ghost" onClick={() => dismiss(n.code)} aria-label={`Dismiss notice: ${n.code}`}>
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
